module.exports = __webpack_public_path__ + "static/img/start-user.02fe9f2b.png";